import {object} from "yup";
import * as Yup from "yup";


export const addressDataValidationSchema = object({
    strasse: Yup.string().required('Straße ist erforderlich'),
    land: Yup.string().required('Land ist erforderlich'),
    plz: Yup.string().required('Postleitzahl ist erforderlich'),
    ort: Yup.string().required('Ortsname ist erforderlich')
})

export type addressDataFormType = Yup.InferType<typeof addressDataValidationSchema>;
